


























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { EButtonType, ITab } from '@getaccept/lib-ui';
import { EWindowSize } from '@/enums/window-size';
import { IRecipient } from '@signing-page/documents/types/recipient';
import SignaturePad from '@signing-page/signing/draw/components/SignaturePad.vue';
import WriteSignature from '@signing-page/signing/components/modals/WriteSignature.vue';
import { IEntity } from '@signing-page/entity/types/entity';
import { isWindowSize } from '@/helpers/window-size.helper';
import { throttle } from '@lib-shared/helpers';

@Component({
  components: {
    SignaturePad,
    WriteSignature,
  },
  data: () => ({
    EButtonType,
  }),
})
export default class VerifySignature extends Vue {
  @Prop() recipient: IRecipient;
  @Prop() loading!: boolean;
  @Prop() entity: IEntity;
  @Prop() signText: string;
  @Prop() signButtonText?: string;

  drawSignatureIsActive = true;

  writeSignatureData: { signatureBase30: string; signatureBase64: string } = {
    signatureBase30: '',
    signatureBase64: '',
  };

  drawSignatureData: { signatureBase30: string; signatureBase64: string } = {
    signatureBase30: '',
    signatureBase64: '',
  };

  isSmallScreen = false;
  isSmallHeightMode = false;

  get tabs(): ITab[] {
    return [
      {
        label: this.$t('draw').toString(),
        key: 'draw',
        isActive: this.drawSignatureIsActive,
      },
      {
        label: this.$t('type').toString(),
        key: 'type',
        isActive: !this.drawSignatureIsActive,
      },
    ];
  }

  get signatureExists(): boolean {
    const typeSignatureExist: boolean =
      this.writeSignatureData.signatureBase30 &&
      this.writeSignatureData.signatureBase64 &&
      !this.drawSignatureIsActive;

    const drawSignatureExist: boolean =
      this.drawSignatureData.signatureBase30 &&
      this.drawSignatureData.signatureBase64 &&
      this.drawSignatureIsActive;

    return !!(typeSignatureExist || drawSignatureExist);
  }

  get signActionText(): string {
    return this.signButtonText || this.$t('sign-document').toString();
  }

  toggleSignatureType() {
    this.drawSignatureIsActive = !this.drawSignatureIsActive;
  }

  handleCancel() {
    this.$emit('cancel');
  }

  handleSign() {
    if (this.drawSignatureIsActive) {
      this.$emit('sign', this.drawSignatureData);
    } else {
      this.$emit('sign', this.writeSignatureData);
    }
  }

  handleReset() {
    this.drawSignatureData = {
      signatureBase30: '',
      signatureBase64: '',
    };
  }

  handleDrawSignature({ signatureBase30, signatureBase64 }) {
    this.drawSignatureData = {
      signatureBase30,
      signatureBase64,
    };
  }

  handleWriteSignature(signature: { signatureBase30: string; signatureBase64: string }) {
    if (signature.signatureBase30 && signature.signatureBase64) {
      this.writeSignatureData = signature;
    } else {
      this.writeSignatureData = {
        signatureBase30: '',
        signatureBase64: '',
      };
    }
  }

  setScreenSize() {
    this.isSmallScreen = isWindowSize(EWindowSize.XSmall);
    this.isSmallHeight();
  }

  isSmallHeight() {
    this.isSmallHeightMode = window.innerWidth > window.innerHeight || window.innerHeight < 600;
  }

  created() {
    window.addEventListener('resize', throttle(this.setScreenSize, 300));
    this.setScreenSize();
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.setScreenSize);
  }
}
